import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkContainer } from '../general-functions';
import CommitteeRow from './committee-row';
import NextButton from './next-button';
import '../global';

class CommitteeInformation extends Component {

	createCommitteeRows() {
		const requestedCommittees = this.props.requestedCommittees.map( committee =>
			                                                                <CommitteeRow name={ committee.TITLE } status='Request Sent' ccode={ committee.CODE } /> );
		const myCommittees = this.props.myCommittees.map( committee =>
			                                                  <CommitteeRow name={ committee.name } status={ committee.member_position } ccode={ committee.code } /> );
		if ( requestedCommittees.length === 0 && myCommittees.length === 0 ) {

			return (<div>
				<h4 class="center-filters">Currently you have no committees.</h4>
				<div id="committee-status-table" class="form-group "></div>
			</div>
			);
		}
		const committees = myCommittees.concat( requestedCommittees );
		return (<div id="committee-status-table" class="table-style form-group ">
			<div class="row no-gutter table-style-header">
				<div class="col-xs-4">Committee</div>
				<div class="col-xs-4">Status</div>
				<div class="col-xs-4">Action</div>
			</div>
			{ committees }
		</div>
		);
	}

	render() {
		const committees = this.createCommitteeRows();
		const sectionName = 'committee-section';
		const active = checkContainer( sectionName, this.props.currentPage );

		return (
			<div id="committee-section" className={ `preferences-section ${active}` }>
				<legend>My Committees and Working Groups</legend>
				{ committees }
				<NextButton gtm_class={ 'committees' } />
			</div>
		);
	}

}

function mapStateToProps( { currentPage, myCommittees, requestedCommittees } ) {
	return {
		currentPage, myCommittees, requestedCommittees
	};
}

export default connect( mapStateToProps )( CommitteeInformation );